import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'vui-iframe-renderer-viewer',
    templateUrl: './iframe-renderer-viewer.component.html',
    styleUrls: ['./iframe-renderer-viewer.component.scss']
})
export class IframeRendererViewerComponent implements OnInit {
    public _srcDoc: SafeHtml;
    public processing: boolean;
    public loaded: boolean;

    constructor(private domSanitizer: DomSanitizer) {
        this.loaded = false;
        this.processing = true;
    }

    ngOnInit(): void {
        this.processing = false;
        this.loaded = true;
    }

    @Input()
    public set srcDoc(srcDoc: string) {
        this._srcDoc = this.domSanitizer.bypassSecurityTrustHtml(srcDoc);
    }
}
